import React from 'react'
import { ellips, fastEmail } from '../../../assets'
import { Button, Input } from '../../../components/Generic'

const Emaill = () => {
  return (
    <>
            <img className="absolute top-[40%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
    <div className='flex flex-col mt-[100px] justify-center items-center z-10'>
      <img className='' src={fastEmail} alt="" />
      <div className='text-gray-darkGray font-sans text-[20px] mt-[24px]'>Repair password</div>
      <div className='text-gray-lightGray font-[Poppins] mt-[25px] text-[15px] font-medium '>We sended code to your  email</div>
      <div className='font-[Poppins] text-gray-lightGray text-[15px] font-medium'>username@gmail.com</div>
      <div className='custom-styles mt-[102px] flex justify-center'>
      <Input style={`h-[60px] px-[15px] md:w-[388px]`} corner={true} placeholder={'username@gmail.com'}/>
      </div>
      <div className='flex justify-between w-full mt-[55px] mb-[97px]'>
        <div className='text-[17px] font-sans'>Emailni o’zgartirish</div>
        <div className='text-blue-chatBlue font-sans text-[17px]'>Qayta jo’natish</div>
      </div>
      <div className='w-[288px] md:w-full flex justify-center mb-[100px]'>
      <Button link={'/settingprofdata'} style={`w-[388px]`} value={'Next'}/>
      </div>
    </div>
    </>
  )
}

export default Emaill